export default {
  computed: {
    tallyFormDefinitions() {
      return [
        {
          testIcon: 'briefcase',
          formName: 'firstaid',
          internalName: 'firstaid',
          gtmFormName: 'firstaid'
        },
        {
          testIcon: 'old',
          formName: 'longevity',
          internalName: 'longevity',
          gtmFormName: 'longevity'
        },
        {
          testIcon: 'healthy-plate',
          formName: 'foodstyle',
          internalName: 'foodstyle',
          gtmFormName: 'foodstyle'
        },
        {
          testIcon: 'stress',
          formName: 'workbalance',
          internalName: 'workbalance',
          gtmFormName: 'workbalance'
        },
        {
          testIcon: 'shield',
          formName: 'intimateHealth',
          internalName: 'intimateHealth',
          gtmFormName: 'intimateHealth'
        },
        {
          testIcon: 'empty-beer',
          formName: 'drinkfree',
          internalName: 'drinkfree',
          gtmFormName: 'drinkfree'
        },
        {
          testIcon: 'sleep-new',
          formName: 'sleephealth',
          internalName: 'sleephealth',
          gtmFormName: 'sleephealth'
        },
        {
          testIcon: 'phone',
          formName: 'digitalhealth',
          internalName: 'digitalhealth',
          gtmFormName: 'digitalhealth'
        },
        {
          testIcon: 'muscle',
          formName: 'flexibility',
          internalName: 'flexibility',
          gtmFormName: 'flexibility'
        },
        {
          testIcon: 'heart-real',
          formName: 'circulation',
          internalName: 'circulation',
          gtmFormName: 'circulation'
        },
        {
          testIcon: 'vitamin',
          formName: 'imunity',
          internalName: 'imunity',
          gtmFormName: 'imun'
        },
        {
          testIcon: 'brain',
          formName: 'adhd',
          internalName: 'adhd'
        },
        {
          testIcon: 'phototype',
          formName: 'skin',
          internalName: 'skin'
        },
        {
          testIcon: 'movement',
          formName: 'move',
          internalName: 'movement'
        },
        {
          testIcon: 'heart',
          formName: 'heart',
          internalName: 'heart'
        },
        {
          testIcon: 'livers',
          formName: 'liver',
          internalName: 'liver'
        },
        {
          testIcon: 'depression',
          formName: 'depression',
          internalName: 'depression'
        },
        {
          testIcon: 'alcohol',
          formName: 'alcohol',
          internalName: 'alcohol'
        },
        {
          testIcon: 'health',
          formName: 'healthCheck',
          internalName: 'healthCheck'
        },
        {
          testIcon: 'sleep',
          formName: 'insomnia',
          internalName: 'insomnia'
        },
        {
          testIcon: 'person-happy',
          formName: 'wellbeing',
          internalName: 'wellbeing'
        },
        {
          testIcon: 'smoke',
          formName: 'nikotinova_zavislost',
          internalName: 'nicotine'
        },
        {
          testIcon: 'report-brain',
          formName: 'test_uzkost',
          internalName: 'anxiety'
        }
      ];
    },
    tallyFormsAvailable() {
      return this.tallyFormDefinitions.filter(test => {
        const urlKey = `tally.${test.internalName}.urls.${
          this.$auth.user?.benefit?.active ? 'b2b' : 'b2c'
        }`;

        return this.$te(urlKey, this.$i18n.locale) && this.$t(urlKey) !== '';
      });
    },
    isTallyAvailable() {
      return this.tallyFormsAvailable.length > 0;
    }
  }
};
